import Flickity from 'flickity';
import 'flickity/css/flickity.css';

(function (Drupal) {
  Drupal.behaviors.brands = {
    attach: function (context, settings) {
      const isHome = document.querySelector('body',context)?.classList.contains('path-frontpage');
      const deviceDetect = {
        breakpointMobile: 768,
        isMobile: () => {
          return window.matchMedia(`(max-width: ${deviceDetect.breakpointMobile}px)`).matches;
        },
      };

      if(isHome && deviceDetect.isMobile()) {
        const flickityContainers = context.querySelectorAll('.view-brands .view-content');
        flickityContainers.forEach(container => {
          new Flickity(container, {
            cellAlign: 'left',
            contain: true,
            groupCells: true,
            prevNextButtons: false,
          });
        });
      }
    }
  }
})(Drupal);
    